import { render, staticRenderFns } from "./UnreadNotification.vue?vue&type=template&id=d514fb9a&"
import script from "./UnreadNotification.vue?vue&type=script&lang=ts&"
export * from "./UnreadNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports